








































































// NOTE: for now this could be moved to plankton if it's needed in other apps
import moment from 'moment'
import DateRangePicker from 'vue2-daterange-picker'

function getStartTime(date) {
  return date
    ? moment(date)
        .startOf('day')
        .format()
    : null
}

function getEndTime(date) {
  return date
    ? moment(date)
        .endOf('day')
        .format()
    : null
}

export default {
  components: { DateRangePicker },
  model: { prop: 'value', event: 'input' },
  props: {
    title: { type: String, required: true },
    noLabel: { type: Boolean, default: false },
    value: {
      type: Object,
      default: () => ({ startDate: '', endDate: '' })
    },
    placeholder: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    fullWidth: { type: Boolean, default: false },
    inline: { type: Boolean, default: false },
    openDirection: {
      type: String,
      default: 'center',
      validator(val) {
        return ['left', 'center', 'right'].includes(val)
      }
    }
  },
  data() {
    return {
      selectedRange: null
    }
  },
  computed: {
    localState: {
      get() {
        const values = Object.values(this.value)
        return {
          startDate: values[0] || values[1],
          endDate: values[1] || values[0]
        }
      },
      set(value) {
        const startDate = value.startDate || value.endDate // Fallback for some cases where the date selection does not work correctly and only an endDate is selected
        this.$emit('input', {
          [this.modelKeys[0]]: getStartTime(startDate),
          [this.modelKeys[1]]: getEndTime(value.endDate)
        })
      }
    },
    modelKeys() {
      return Object.keys(this.value)
    },
    ranges() {
      return {
        [this.$t('calendar.today')]: { startDate: moment(), endDate: moment() },
        [this.$t('calendar.tomorrow')]: {
          startDate: moment().add(1, 'days'),
          endDate: moment().add(1, 'days')
        },
        [this.$t('calendar.nextWeek')]: {
          startDate: moment()
            .add(1, 'week')
            .startOf('week')
            .add(1, 'days'),
          endDate: moment()
            .add(1, 'week')
            .endOf('week')
            .add(1, 'days')
        }
      }
    },
    locale() {
      return {
        format: 'DD.MM.YYYY',
        firstDay: 1,
        applyLabel: this.$t('calendar.ok'),
        cancelLabel: this.$t('calendar.cancel'),
        fromLabel: this.$t('calendar.from'),
        toLabel: this.$t('calendar.to'),
        daysOfWeek: [
          this.$t('calendar.sunday'),
          this.$t('calendar.monday'),
          this.$t('calendar.tuesday'),
          this.$t('calendar.wednesday'),
          this.$t('calendar.thursday'),
          this.$t('calendar.friday'),
          this.$t('calendar.saturday')
        ],
        monthNames: [
          this.$t('calendar.january'),
          this.$t('calendar.february'),
          this.$t('calendar.march'),
          this.$t('calendar.april'),
          this.$t('calendar.may'),
          this.$t('calendar.june'),
          this.$t('calendar.july'),
          this.$t('calendar.august'),
          this.$t('calendar.september'),
          this.$t('calendar.october'),
          this.$t('calendar.november'),
          this.$t('calendar.december')
        ]
      }
    },
    nothingSelected() {
      return !this.localState.startDate && !this.localState.endDate
    },
    formFieldClasses() {
      return {
        'input-wrapper': true,
        'input-wrapper--full-width': this.fullWidth
      }
    },
    inputFieldClasses() {
      return {
        'input-field': true,
        'input-field--inline': this.inline,
        'input-field--disabled': this.disabled
      }
    }
  },
  methods: {
    onClickRange(name, range) {
      this.localState = range
      this.selectedRange = name
    },
    onClickReset() {
      this.localState = {}
      this.onUpdate()
      this.close()
    },
    onToggle(open) {
      if (open) {
        this.$refs.selectable.focus()
        this.$emit('open')
      } else this.$refs.selectable.blur()
    },
    onUpdate() {
      this.selectedRange = null
    },
    close() {
      this.$refs.picker.clickAway()
    },
    onInputFocus() {
      this.$refs.picker.togglePicker(true)
    },
    onInputBlur(e) {
      if (e.relatedTarget && this.$el.contains(e.relatedTarget)) return
      else this.close()
    },
    onTabClick(e) {
      // hack: if the active element is the last selectable element (next month arrow button)
      // close the calendar window
      // Could be resolved by https://github.com/Innologica/vue2-daterange-picker/issues/149
      const selectableEls = this.$el.querySelectorAll('button, [tabindex]')
      if (selectableEls) {
        const lastSelectableEl = selectableEls[selectableEls.length - 1]
        if (!e.shiftKey && e.target === lastSelectableEl) this.close()
      }
    }
  }
}
